import { Injectable, ComponentRef, ApplicationRef, ComponentFactoryResolver, Injector } from '@angular/core';
import { PhoneConfirmationComponent } from './phone-confirmation.component';

@Injectable()
export class PhoneConfirmationService {
  private phoneConfirmationComponent: ComponentRef<PhoneConfirmationComponent>;

  constructor(
    private componentFactoryResolver: ComponentFactoryResolver,
    private applicationRef: ApplicationRef,
    private injector: Injector
  ) {}

  showPhoneConfirmationModal() {
    if (!this.phoneConfirmationComponent) {
      this.phoneConfirmationComponent = this.componentFactoryResolver
        .resolveComponentFactory(PhoneConfirmationComponent)
        .create(this.injector);
      this.applicationRef.attachView(this.phoneConfirmationComponent.hostView);
      this.phoneConfirmationComponent.changeDetectorRef.detectChanges();
    }
    this.phoneConfirmationComponent.instance.showInitialModal();
  }
}
